(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aham-home-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aham-home-hub')) {
  customElements.define('aham-home-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.classList.add('is-enhanced');
      const track = this.querySelector('.aham-hub__track');
      const slides = [...this.querySelectorAll('[data-brand-slide]')];
      const brand = this.querySelector('.aham-hub__brands');
      const pause = this.querySelector('[data-brand-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      let hovered = false;
      let visible = true;
      let userPaused = reduced.matches;
      const updatePause = () => { if (pause) { pause.textContent = userPaused ? this.dataset.playLabel : this.dataset.pauseLabel; pause.setAttribute('aria-label', pause.textContent); } };
      const move = direction => { const next = (active + direction + slides.length) % slides.length; track.scrollTo({left:slides[next].offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth'}); };
      const schedule = () => {
        clearTimeout(this.timer);
        if (slides.length < 2 || userPaused || hovered || document.hidden || !visible || brand.contains(document.activeElement)) return;
        this.timer = setTimeout(() => { move(1); schedule(); }, 10000);
      };
      this.querySelector('[data-brand-prev]')?.addEventListener('click', () => { move(-1); schedule(); }, opts);
      this.querySelector('[data-brand-next]')?.addEventListener('click', () => { move(1); schedule(); }, opts);
      pause?.addEventListener('click', () => { userPaused = !userPaused; updatePause(); schedule(); }, opts);
      track.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); schedule(); } }, opts);
      track.addEventListener('scroll', () => {
        active = Math.max(0,Math.min(slides.length - 1,Math.round(track.scrollLeft / track.clientWidth)));
        const counter = this.querySelector('[data-brand-current]');
        if (counter) counter.textContent = String(active + 1);
        slides.forEach((slide,i) => { slide.inert = i !== active; });
        schedule();
      }, {...opts, passive:true});
      brand.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; schedule(); } }, opts);
      brand.addEventListener('pointerleave', () => { hovered = false; schedule(); }, opts);
      brand.addEventListener('focusin', schedule, opts);
      brand.addEventListener('focusout', () => queueMicrotask(schedule), opts);
      document.addEventListener('visibilitychange', schedule, opts);
      reduced.addEventListener('change', () => { userPaused = reduced.matches; updatePause(); schedule(); }, opts);
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
      this.observer.observe(brand);
      slides.forEach((slide,i) => { slide.inert = i !== 0; });
      updatePause(); schedule();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); this.events = null; this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aham-offer-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aham-offer-slideshow')) {
    customElements.define('aham-offer-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.aham-offer__track');
        const slides = [...this.querySelectorAll('[data-aham-slide]')];
        let active = 0;
        const move = (direction) => {
          active = (active + direction + slides.length) % slides.length;
          track.scrollTo({left: slides[active].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.querySelector('[data-aham-previous]')?.addEventListener('click', () => move(-1));
        this.querySelector('[data-aham-next]')?.addEventListener('click', () => move(1));
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        track.addEventListener('scroll', () => {
          active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          const counter = this.querySelector('[data-aham-current]');
          if (counter) counter.textContent = String(active + 1);
          slides.forEach((slide, index) => { slide.inert = index !== active; });
        }, {passive:true});
        slides.forEach((slide, index) => { slide.inert = index !== 0; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aham-welcome-popup"]) return;
  try {
    
  if (!customElements.get('aham-welcome-popup')) {
    customElements.define('aham-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const form = this.querySelector('form');
        if (!dialog) return;
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
        const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
        let opener;
        const open = () => {
          clearTimeout(this.timer);
          if (dialog.open) return;
          opener = document.activeElement;
          dialog.showModal();
          dialog.querySelector('[data-aham-success], .aham-welcome__email, [data-aham-close]')?.focus({preventScroll:true});
        };
        const close = () => dialog.close();
        dialog.addEventListener('close', () => {
          write(sessionStorage, 'aham-welcome-dismissed', '1');
          if (opener instanceof HTMLElement && opener !== document.body) opener.focus({preventScroll:true});
        }, options);
        this.querySelectorAll('[data-aham-close]').forEach(button => button.addEventListener('click', close, options));
        dialog.addEventListener('click', event => { if (event.target === dialog) { const rect=dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } }, options);
        document.addEventListener('click', event => {
          if (event.target.closest('[data-aham-signup], a[href="#aham-welcome"]')) { event.preventDefault(); open(); }
        }, options);
        form?.addEventListener('submit', () => { write(sessionStorage,'aham-welcome-submitted','1'); }, options);
        const hasSuccess = Boolean(this.querySelector('[data-aham-success]'));
        const hasErrors = Boolean(this.querySelector('[data-aham-errors]'));
        const submitted = read(sessionStorage,'aham-welcome-submitted') === '1';
        if (hasSuccess && submitted) {
          write(localStorage,'aham-welcome-complete','1'); write(sessionStorage,'aham-welcome-submitted',''); open();
        } else if (hasErrors && submitted) {
          open();
        } else if (this.dataset.designMode !== 'true' && this.dataset.skipAuto !== 'true' && !read(sessionStorage,'aham-welcome-dismissed') && !read(localStorage,'aham-welcome-complete') && !location.pathname.startsWith('/challenge')) {
          this.timer = setTimeout(open, 2500);
        }
      }
      disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); this.initialized=false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
